import { colorTokenFromNestedArguments, referenceForwardArgs, sizeConst } from '@klarna/designtokens';
export var componentTokenOverrides = {
  'alert-block/icon-color': colorTokenFromNestedArguments({
    error: (fromRef, args) => fromRef('colors/text/error-on-background', args),
    warning: (fromRef, args) => fromRef('colors/text/warning-on-background', args),
    success: (fromRef, args) => fromRef('colors/text/success-on-background', args),
    default: (fromRef, args) => fromRef('colors/text/accent-on-background', args)
  }, ['status']),
  'dropdown/corner-radius': referenceForwardArgs('corner-radius/m'),
  'field/corner-radius': referenceForwardArgs('corner-radius/m'),
  'field-money/corner-radius': referenceForwardArgs('corner-radius/m'),
  'masked-field/corner-radius': referenceForwardArgs('corner-radius/m'),
  'navbar/icon-size': sizeConst(24),
  'takeover/icon-color': colorTokenFromNestedArguments({
    error: (fromRef, args) => fromRef('colors/text/error-on-background', args),
    warning: (fromRef, args) => fromRef('colors/text/warning-on-background', args),
    success: (fromRef, args) => fromRef('colors/text/success-on-background', args),
    default: (fromRef, args) => fromRef('colors/text/accent-on-background', args)
  }, ['status']),
  'toast/icon-color': colorTokenFromNestedArguments({
    error: (fromRef, args) => fromRef('colors/text/error-on-background', args),
    warning: (fromRef, args) => fromRef('colors/text/warning-on-background', args),
    success: (fromRef, args) => fromRef('colors/text/success-on-background', args),
    default: (fromRef, args) => fromRef('colors/text/accent-on-background', args)
  }, ['status'])
};
//# sourceMappingURL=componentTokenOverrides.js.map